import substituteVars from './substituteVars';
/**
 * Checks to see if ION's Application is present and pulls it's fields from the rest
 * of the objects.
 *
 * The returned array is a ref to the 'application.fields' property.
 * This method is used mostly for other utilities. If you're looking to get access to
 * the ION's fields in a simple to traverse, immutable dataset, try getFields() instead.
 * @param {object} ion - An ION Instance
 * @returns {import('../model').Field[]} Application fields
 * @memberof module:ionHelpers
 */
const getApplicationFields = (ion) => {
    // substitute $variables and then pull out application
    const { application } = substituteVars(ion);
    if (!application?.fields?.length) {
        // TODO: Discuss how we want to handle these errors.
        // eslint-disable-next-line no-console
        console.warn('ION is missing application fields');
        return [];
    }
    return application.fields;
};
export default getApplicationFields;
